module.exports = __webpack_public_path__ + "img/1-300x160.734f0d9c.jpg";